import ContinuePage from "@components/ContinuePage"

export default function LooksmaxxingAlmostTherePage() {
  return <ContinuePage emoji="🔬" translationKey="almostThereLooksmaxxing" />
}
